import { styled } from '@mui/material/styles'
import { Footer as SuiFooter } from './components/Footer/Footer'
import { Header as SuiHeader } from './components/Header/Header'

export const Footer = styled(SuiFooter)({})
export const Header = styled(SuiHeader)({})
